import axios from 'axios'

export const registerMultiple = users => {
    return axios.post('/ajax/register-multiple', { users })
}
export const addUser = userInfo => {
    return axios.post('/ajax/register', userInfo)
}
export const addAdminUser = adminInfo => {
    return axios.post('/ajax/register-admin', adminInfo)
}
export const loginViaLink = data => {
    return axios.get(`/ajax/use-login-link`, { params: { ...data } })
}
